import { useContext, useId } from "react";

import { SxProps } from "@mui/material";
import { DonationFormCategory, FormType } from "@simplyk/common";

import { FormCheckbox } from "../../../../components/forms-design-system/FormCheckbox";
import { FrontendFormContext } from "../../../../contexts/FrontendFormContext";
import { useFormV2Context } from "../../context/FormV2Context";

import { useTranslate } from "@/hooks/useTranslate";

type PublicDonationCheckboxProps = {
  sx?: SxProps;
};

export const PublicDonationCheckbox = ({ sx }: PublicDonationCheckboxProps) => {
  const { form } = useFormV2Context(FormType.DonationForm);
  const { t } = useTranslate();

  return (
    <FormCheckbox
      control={form.control}
      name="isPublicDonation"
      id={useId()}
      label={t("donationForm", "isPublicDonation")}
      defaultChecked={true}
      sx={sx}
    />
  );
};

export const usePublicDonationCheckboxRenderPosition = () => {
  const { type, formObject } = useFormV2Context();
  const { displayExpressCheckout, category } = useContext(FrontendFormContext);

  if (type !== FormType.DonationForm) {
    return null;
  }

  if (category === DonationFormCategory.DonationForm && formObject.target === null) {
    return null;
  }

  return displayExpressCheckout ? "summary-section" : "your-information-section";
};
